import qs from 'qs';

export const serializableTypes = {
    text: 'text/plain',
    json: 'application/json',
    form: 'application/x-www-form-urlencoded',
    multipart: 'multipart/form-data',
};

const deserializableTypes = {
    text: [
        'text/plain',
    ],
    json: [
        'application/json',
        'application/json-patch+json',
        'application/vnd.api+json',
        'application/csp-report',
    ],
    form: [
        'application/x-www-form-urlencoded',
    ],
    multipart: [],
};

type RequestBody = object | string | FormData;
type ContentType = 'text' | 'json' | 'form' | 'multipart';

const isContentType = (resContentType: string, contentType: ContentType) => {
    for (const type of deserializableTypes[contentType]) {
        if (resContentType.includes(type)) return true;
    }
    return false;
};

export function parseQuery(query?: object | string) {
    if (!query) return '';
    if (typeof query === 'string') return '?' + query;
    return '?' + qs.stringify(query);
}

export function serialize(body: RequestBody, contentType: ContentType) {
    if (contentType === 'json') {
        return JSON.stringify(body as object);
    }
    return body as FormData | string;
}

export function deserialize(res: Response) {
    if (res.status === 204) return;
    const contentType = res.headers.get('content-type');
    if (!contentType) return;
    try {
        if (isContentType(contentType, 'json')) {
            return res.json();
        }
        if (isContentType(contentType, 'text')) {
            return res.text();
        }
        if (isContentType(contentType, 'form')) {
            return res.formData();
        }
    } catch (e) {
        return res.body;
    }
}